import { render, staticRenderFns } from "./payouts.vue?vue&type=template&id=69b70ad1&scoped=true&"
import script from "./payouts.vue?vue&type=script&lang=js&"
export * from "./payouts.vue?vue&type=script&lang=js&"
import style0 from "./payouts.vue?vue&type=style&index=0&id=69b70ad1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b70ad1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69b70ad1', component.options)
    } else {
      api.reload('69b70ad1', component.options)
    }
    module.hot.accept("./payouts.vue?vue&type=template&id=69b70ad1&scoped=true&", function () {
      api.rerender('69b70ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/payouts.vue"
export default component.exports